export interface AlgoverseDeploymentCostModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  isPremium: boolean;
}

export enum DEPLOYMENT_STATUS {
  LOADING = 'LOADING',
  CONFIRMATION = 'CONFIRMATION',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
}
